import './App.css';
import { MainTodo } from './components/TheMainList/MainList';

function App() {
  return (
    <>
      <MainTodo />
    </>
  );
}

export default App;
